import { gql } from "@apollo/client";

export const GET_SERVICES_BY_ORGANIZATION_ID = gql`
  query GetAllServicesByOrgId($orgId: String!) {
    getAllServicesByOrgId(orgId: $orgId) {
      id
      orgId
      name
      status
      alternateName
      description
      url
      email
      interpretationServices
      applicationProcess
      waitTime

      cost
      accreditations
      licenses
      subOpCategory
      opCategory
      requiredDocuments
      paymentsAccepted
      eligibilities
      fundings
      serviceAreas
      languages
      createdAt
      referrals {
        id
        # user
        userId
        eligibilityStatus
        serviceId
        serviceName
        orgId
        status
        isSelfReferral
      }
      # draft
    }
  }
`;
